import { addDays, format, subMonths, subWeeks } from "date-fns";

const REPORT_DATE_FORMAT = "yyyy-MM-dd";

export const getDefaultReportDateRange = (baseDate = new Date()) => {
  const endDate = addDays(baseDate, 1);
  const startDate = subMonths(baseDate, 1);

  return {
    startDate: format(startDate, REPORT_DATE_FORMAT),
    endDate: format(endDate, REPORT_DATE_FORMAT),
  };
};

export const getDefaultBuilderDateRange = (baseDate = new Date()) => {
  const endDate = addDays(baseDate, 1);
  const startDate = subWeeks(endDate, 1);

  return {
    startDate: format(startDate, REPORT_DATE_FORMAT),
    endDate: format(endDate, REPORT_DATE_FORMAT),
  };
};

const defaultDateRange = getDefaultReportDateRange();

export const START_DATE = defaultDateRange.startDate;
export const END_DATE = defaultDateRange.endDate;

const builderDefaultDateRange = getDefaultBuilderDateRange();

export const BUILDER_START_DATE = builderDefaultDateRange.startDate;
export const BUILDER_END_DATE = builderDefaultDateRange.endDate;
